import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/sino-biz/winBulletin/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getVerifyList = (current, size, params) => {
  return request({
    url: '/api/sino-biz/winBulletin/verifyPage',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/sino-biz/winBulletin/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/sino-biz/winBulletin/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/sino-biz/winBulletin/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/sino-biz/winBulletin/submit',
    method: 'post',
    data: row
  })
}

export const submitWinBulletin = (row) => {
  return request({
    url: '/api/sino-biz/winBulletin/submitWinBulletin',
    method: 'post',
    data: row
  })
}

export const verifyInfo = (row) => {
  return request({
    url: '/api/sino-biz/winBulletin/verifyInfo',
    method: 'post',
    data: row
  })
}

